import { ChevronDown, ChevronUp } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';

import { getMonthLabel } from '../../lib/get-month-label';

type Props = {
    selectedDay: Date;
    shownMonth: Date;
    today: Date;
    isPickerOpen: boolean;
    onToggle: () => void;
    onToday: () => void;
};

export function CalendarPageDateBar({
    selectedDay,
    shownMonth,
    today,
    isPickerOpen,
    onToggle,
    onToday,
}: Props) {
    // shownMonth keeps a swiped-to month after the picker closes.
    const label = getMonthLabel(isPickerOpen ? shownMonth : selectedDay, today);
    const Chevron = isPickerOpen ? ChevronUp : ChevronDown;

    return (
        // 16px, not Figma's 8px: that 8px sits beside the settings gear, which NSS-640 adds.
        // Sticky and opaque: the phone column scrolls beneath it on short screens.
        <div
            className={cn(
                'sticky top-0 z-10 flex h-11 shrink-0 items-center justify-between border-b bg-card px-4 transition-colors duration-200 ease-out',
                isPickerOpen ? 'border-transparent' : 'border-border',
            )}
        >
            <Button
                variant="ghost"
                size="sm"
                className="font-semibold px-0 gap-2.5"
                aria-expanded={isPickerOpen}
                onClick={onToggle}
            >
                {label}
                <Chevron />
            </Button>
            <Button variant="outline" size="sm" onClick={onToday}>
                Today
            </Button>
        </div>
    );
}
